import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter, Routes, Route , Navigate , useParams
} from 'react-router-dom';
import { AppProvider } from './context';
import './index.css';
import './ql-Editor.css';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home/Home';
import Login from "./pages/Login/Login";
import BookList from "./components/BookList/BookList";
import BookDetails from "./components/BookDetails/BookDetails";
import Register from "./pages/Login/Register";

import EPDF from "./components/EPDF/EPDF";

const root = ReactDOM.createRoot(document.getElementById('root'));

// const RedirectToView = () => {
//   const { id } = useParams();
//   return <Navigate to={`/view/${id}`}  />;
// };

root.render(
  <HelmetProvider >
  <AppProvider >
 <BrowserRouter basename="/index">
      <Routes>
        <Route path = "/" element = {<Home />}>
          <Route path = "book" element = {<BookList />} />
          <Route path = "journal" element = {<BookList />} />
          <Route path = "/book/:id" element = {<BookDetails />} />
          <Route path = "/journal/:cat/:id" element = {<BookDetails />} />
          <Route path = "/journal/:id" element = {<BookList />} />
        </Route>
        <Route path="/EPDF/:id" element={<EPDF />} />
        <Route path="/view/:id" element={<EPDF />} />
        <Route path = "/login/f855ee54-e3ae-4957-be11-5201c533856e" element = {<Login />} />
        {/*<Route path = "/register/f855ee54-e3ae-4957-be11-5201c533856e" element = {<Register />} />*/}

      </Routes>
    </BrowserRouter>
  </AppProvider>
</HelmetProvider>
);

